import {IMuWidget} from "./IMuWidget";

export class TicketFormField extends IMuWidget {
	static readonly CollapsedNo = 0;
	static readonly CollapsedDefaultYes = 1;
	static readonly CollapsedDefaultNo = 2;

	public collapsed : number = TicketFormField.CollapsedDefaultYes;

	beforeIndex() {
		if (this.collapsed !== TicketFormField.CollapsedNo)
		{
			const bExpand = this.container.querySelector('[mu-id="bExpand"]');
			if (!bExpand) {
				const label = this.container.querySelector('[mu-id="label"]');
				if (label) label.innerHTML = '<span mu-id="bExpand" class="ticket-form-field--expander"></span>' + label.innerHTML;
			}
		}
	}

	afterIndex() {
		super.afterIndex();
		if (this.collapsed !== TicketFormField.CollapsedNo) this.setOpen(this.collapsed !== TicketFormField.CollapsedDefaultYes);
	}

	setOpen(isOpen: boolean|undefined = undefined) {
		if (isOpen !== undefined)
			this.container.classList.toggle("ticket-form-field__collapsed", !isOpen);
		else this.container.classList.toggle("ticket-form-field__collapsed");
	}

	bExpand_click() {
		this.setOpen();
		// event.stopPropagation();
		event.preventDefault();
	}
}